import React from 'react';
import PropTypes from 'prop-types';
import {
  Text, View, Platform, StyleSheet,
} from 'react-native';
import { moderateScale } from 'react-native-size-matters';
import { ProgramsConfig } from 'fitbeat.gym-core';
import { GymTypes } from 'fitbeat.models';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import { workoutTypeWithBodyGroups } from '../utils';

function WorkoutTypeWithBodyGroupText({
  t,
  workoutSettings,
  gym = {},
}) {
  return (
    <View>
      <Text style={[Theme.textStyle.heading2, { marginBottom: defaultScale(18) }]}>
        {workoutTypeWithBodyGroups(workoutSettings, t)}
      </Text>
      <Text style={Theme.textStyle.bodyCopyReg}>
        {ProgramsConfig.getWorkoutSettingDescription(
          workoutSettings,
          gym.type === GymTypes.Home,
          !!gym.bagContactAllowed,
        )}
      </Text>
    </View>
  );
}

WorkoutTypeWithBodyGroupText.propTypes = {
  t: PropTypes.func.isRequired,
  workoutSettings: PropTypes.object.isRequired,
  themedStyles: PropTypes.object,
};

export const themedStyles = {
  light: {
    backgroundColor: Theme.WHITE,
  },
  dark: {
    backgroundColor: Theme.GREY_LIGHT,
    padding: 15,
    marginVertical: 10,
    borderRadius: 5,
  },
};

const styles = StyleSheet.create({
  container: {
    paddingBottom: 10,
  },
  header: {
    paddingVertical: 5,
  },
  description: {
    fontFamily: Theme.Custom300,
    fontSize: moderateScale(14, 1),
    fontWeight: 'normal',
    color: Theme.GREY_DARK_MEDIUM,
    paddingTop: 5,
    ...Platform.select({
      web: {
        fontSize: 14,
      },
    }),
  },
});

export default WorkoutTypeWithBodyGroupText;
